import type { GetStaticPaths, GetStaticProps } from 'next';
import { LegalPage } from '../../components/LegalPage';
import { LEGAL_DOCS, type LegalDoc } from '../../content/legal';

interface Props {
  doc: LegalDoc;
}

export default function LegalDocPage({ doc }: Props) {
  return <LegalPage doc={doc} />;
}

export const getStaticPaths: GetStaticPaths = async () => ({
  paths: Object.keys(LEGAL_DOCS).map((slug) => ({ params: { slug } })),
  fallback: false,
});

export const getStaticProps: GetStaticProps<Props> = async ({ params }) => {
  const slug = params?.slug as string;
  const doc = LEGAL_DOCS[slug];
  if (!doc) return { notFound: true };
  return { props: { doc } };
};
